// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33wbl","title":"styles_title__3ZOSA"};